import { createFeatureSelector } from '@ngrx/store';
import { AppState } from '@app/sharedModule/models/app-state.model';
import * as fromAssign from '../reducers/index';

export const assignSelector = createFeatureSelector<AppState, fromAssign.AssignState>(fromAssign.featureKey);
